import React, { useState, useEffect } from 'react';
import Sessions from './Sessions';
import LiquidFillLoader from '../../../shared/components/ui/LiquidFillLoader';
// OnchainTab removed - onchain functionality removed

const ActivityPage = ({ onMenuClick, screenSize, selectedPage }) => {
  const [idy, setidy] = useState(null);
  const [isLoadingWebsites, setIsLoadingWebsites] = useState(true);

  // Load website ID after websites are fetched
  useEffect(() => {
    const loadWebsiteId = () => {
      const storedId = localStorage.getItem("idy");
      setidy(storedId);
      setIsLoadingWebsites(false);
    };
    
    // Wait a bit for website fetching to complete
    const timer = setTimeout(loadWebsiteId, 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="flex h-screen overflow-hidden relative">
      {/* Content area with header and flexible content */}
      <div className="flex flex-col w-full h-screen relative z-10">
        {/* Tab Navigation removed - only offchain sessions now */}

        {/* Main content area - full width */}
        <div className="flex flex-1 overflow-hidden">
          {isLoadingWebsites ? (
            <div className="flex-grow overflow-y-auto p-6">
              <div className="bg-[#DDE2EE] border border-gray-300 p-6">
                <div className="flex flex-col items-center justify-center py-12">
                  <LiquidFillLoader size={100} />
                  <span className="mt-4 text-sm text-[#0f172a] font-medium" style={{ fontFamily: 'Raleway, sans-serif' }}>
                    Loading websites...
                  </span>
                </div>
              </div>
            </div>
          ) : idy ? (
            <Sessions 
              onMenuClick={onMenuClick}
              screenSize={screenSize}
              selectedPage={selectedPage}
            />
          ) : (
            <div className="flex-grow overflow-y-auto p-6">
              <div className="bg-[#DDE2EE] border border-gray-300 p-6">
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    <div className="w-8 h-8 bg-black flex items-center justify-center">
                      <svg className="h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                      </svg>
                    </div>
                  </div>
                  <div className="ml-3">
                    <p className="text-sm text-[#0f172a] font-medium" style={{ fontFamily: 'Raleway, sans-serif' }}>
                      Please select a website to view activity.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ActivityPage;
